import { isVariantEnabled } from "../featureFlags";

export const getEnabledVariant = (experiments, variants) => {
  return variants.find(variant => experiments[variant]);
};

const DEFAULT_CONFIG_KEY = 'base';
export const generateVariantData = (config, defaultVariant = DEFAULT_CONFIG_KEY) => variant =>
  config[variant] || config[defaultVariant];

export const generateExperimentSetupMapping = mapping => (experimentName, variant) => {
  const variantPlanMapping = mapping[experimentName];

  if (variantPlanMapping) {
    return variantPlanMapping[variant];
  }
};

export const isControl = variant => isVariantEnabled(variant) && variant.name === 'control';
export const isVariantNumber = (variant, num) =>
  isVariantEnabled(variant) && variant.name === `variant${num}`;
export const isVariant = variant => !isControl(variant);



// WEBPACK FOOTER //
// ./src/experiments/utils.js